module.exports = __webpack_public_path__ + "img/13.f3fda295.png";